<template>
  <div>
    <vx-card :title="`Список заказов | Всего ${totalOrders}`" class="p-6">
      <vs-row class="mb-5">
        <div class="header-filter md:w-1/6 w-full mb-5 mr-5 cursor-pointer">
          <v-select
            @input="getOrders()"
            :options="countItemsOmPage"
            :clearable="false"
            placeholder="Количество товаров"
            v-model="countElements"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>
      </vs-row>

      <vs-table
        :data="orders"
        :stripe="true"
        :search="false"
        :pagination="false"
        :maxItems="20"
        noDataText="Элементов не найдено"
        id="div-with-loading"
      >
        <template slot="thead">
          <vs-th> # </vs-th>
          <vs-th> Продукты </vs-th>
          <vs-th> Сумма </vs-th>
          <vs-th> Детали заказа </vs-th>
          <vs-th> Статус </vs-th>
          <vs-th> Действия </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              {{ data[indextr].id }}
            </vs-td>

            <vs-td>
              <a
                v-for="(product, index) in data[indextr].products"
                :key="index"
                :href="`/cafe/dishes/${product.product.id}`"
                class="mb-3 block"
              >
                {{ index + 1 }}. {{ product.product.name }} x
                {{ product.quantity }}
              </a>
            </vs-td>

            <vs-td>
              {{ data[indextr].price }}
            </vs-td>

            <vs-td>
              <p class="mb-3">
                Дата доставки:
                <span class="text-primary">{{
                  data[indextr].date_predicted
                }}</span>
              </p>
              <p v-if="data[indextr].comment" class="mb-3">
                Комментарий:
                <span class="text-primary">{{ data[indextr].comment }}</span>
              </p>
              <p class="mb-3">
                Тип доставки:
                <span class="text-primary">{{ data[indextr].kind.name }}</span>
              </p>
            </vs-td>

            <vs-td>
              <p class="mb-2">
                {{ data[indextr].is_delivered ? "Доставлен" : "Не доставлен" }}
              </p>
              <vs-chip v-if="data[indextr].is_paid" color="success"
                >Оплачен</vs-chip
              >
              <vs-chip v-else color="danger">Не оплачен</vs-chip>
            </vs-td>

            <vs-td>
              <vx-tooltip class="inline-block" text="Детали заказа">
                <vs-button
                  :href="`/market/orders/${data[indextr].id}`"
                  color="dark"
                  class="text-dark mr-3"
                  icon-pack="feather"
                  icon="icon-eye"
                  size="large"
                  type="flat"
                ></vs-button>
              </vx-tooltip>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination
        class="mt-4"
        :total="totalPagePagination"
        v-model="currentPagingationPage"
      ></vs-pagination>
    </vx-card>
  </div>
</template>
<script>
import { API_URL, countItemsOmPage, deliveryType } from "@/.env";

import { DateTime } from "luxon";

export default {
  data: () => ({
    BASE_URL: API_URL,
    orders: [],

    filter: {},
    countElements: 20,
    currentPagingationPage: 1,
    totalOrders: 0,
    totalPagePagination: 1,
    countItemsOmPage,
  }),
  components: {
    DateTime,
  },
  watch: {
    countElements: function () {
      this.currentPagingationPage = 1;
      this.getOrders();
    },
    currentPagingationPage: function () {
      this.getOrders();
    },
  },
  computed: {},
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    getOrders() {
      this.$vs.loading();

      this.filter.page =
        this.currentPagingationPage !== 1 ? this.currentPagingationPage : 1;
      this.filter.limit = this.countElements !== 20 ? this.countElements : 20;

      this.$load(async () => {
        let res = (await this.$api.market.getOrders(this.filter)).data;

        this.totalOrders = res.count;
        this.totalPagePagination = Math.ceil(
          this.totalOrders / this.countElements
        );

        res.results.forEach((order) => {
          order.date_predicted = DateTime.fromISO(
            order.date_predicted
          ).toLocaleString(DateTime.DATETIME_SHORT);
          order.kind = deliveryType.find((x) => x.id == order.kind);
        });

        this.orders = res.results;
        this.$vs.loading.close();
      });
    },
  },
  created() {},
  mounted() {
    this.getOrders();
  },
};
</script>